<template>
  <v-layout>
    <div class="container">
      <div class="row mt-5 card-deck">
        <div class="card jellyfish col-sm-6">
          <div class="card-body">
            <h5 class="card-title">{{ $t('login.welcomeTitle') }}</h5>
            <p class="card-text">{{ $t('login.welcomeText') }}</p>
            <router-link
              :to="{ name: 'register.index' }"
              class="card-link"
              tag="a"
            >
              {{ $t('login.dontHaveAnAccount') }}
            </router-link>
            <br>
            <router-link
              :to="{ name: 'forgot-password.index' }"
              class="card-link"
              tag="a"
            >
              {{ $t('login.forgotYourPassword') }}
            </router-link>
          </div>
        </div>
        <div class="card jellyfish col-sm-6">
          <div class="card-body">
              <h5 class="card-title">{{ $t('login.alreadyRegistered')}}</h5>
              <form class="form" @submit.prevent="login">
                <div class="form-group">
                  <div class="input-group">
                    <div class="input-group-prepend">
                <span class="input-group-text">
                  <i class="fa fa-envelope fa-fw" />
                </span>
                    </div>
                    <input
                      v-model="user.username"
                      type="email"
                      :placeholder="$t('Email')"
                      class="form-control"
                    >
                  </div>
                </div>
                <div class="form-group">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text">
                        <i class="fa fa-lock fa-fw" />
                      </span>
                    </div>
                    <input
                      v-model="user.password"
                      type="password"
                      :placeholder="$t('Password')"
                      class="form-control"
                    >
                  </div>
                  <small v-if="error" class="text-danger d-block">{{ $t(error) }}</small>
                </div>
                <div class="form-group">
                  <button class="btn btn-block"
                          :disabled="!credentialsValid"
                          :class="{'btn-outline-primary': !credentialsValid, 'btn-primary': credentialsValid}"
                          v-if="!working"
                  >
                    {{ $t('login.loginButton') }}
                  </button>
                  <b-button v-else variant="primary" block disabled>
                    <b-spinner small type="border"></b-spinner>
                  </b-button>
                </div>
              </form>
            </div>
        </div>
      </div>

      <!-- dvije kartice odvojene -->


      <!-- jedna kartica -->
      <div class="card mt-2 d-none">
        <div class="card-body">
          <div class="row">
            <div class="col-sm-6 mb-4">
              <h4>{{ $t('login.welcomeTitle') }}</h4>
              <p>{{ $t('login.welcomeText') }}</p>
              <router-link
                :to="{ name: 'register.index' }"
                class="card-link"
                tag="a"
              >
                {{ $t('login.dontHaveAnAccount') }}
              </router-link>
              <br>
              <router-link
                :to="{ name: 'forgot-password.index' }"
                class="card-link"
                tag="a"
              >
                {{ $t('login.forgotYourPassword') }}
              </router-link>
            </div>
            <div class="col-sm-6">
              <h4>{{ $t('login.alreadyRegistered')}}</h4>
              <form class="form" @submit.prevent="login">
                <div class="form-group">
                  <div class="input-group">
                    <div class="input-group-prepend">
                <span class="input-group-text">
                  <i class="fa fa-envelope fa-fw" />
                </span>
                    </div>
                    <input
                      v-model="user.username"
                      type="email"
                      placeholder="Email"
                      class="form-control"
                    >
                  </div>
                </div>
                <div class="form-group">
                  <div class="input-group">
                    <div class="input-group-prepend">
                <span class="input-group-text">
                  <i class="fa fa-lock fa-fw" />
                </span>
                    </div>
                    <input
                      v-model="user.password"
                      type="password"
                      placeholder="Password"
                      class="form-control"
                    >
                  </div>
                </div>
                <div class="form-group">
                  <button class="btn btn-block"
                          :disabled="!credentialsValid"
                          :class="{'btn-outline-primary': !credentialsValid, 'btn-primary': credentialsValid}"
                  >
                    {{ $t('login.loginButton') }}
                  </button>
                </div>
              </form>
              <div class="text-center">
                <div v-if="working" class="spinner-border text-primary text-center"></div>
              </div>
              <div class="alert alert-danger"
                   v-if="error"
              >
                <h4 class="alert-heading">{{ $t('Error') }}</h4>
                {{ $t(error) }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </v-layout>
</template>

<script>
  import VLayout from '@/layouts/MinimalWithNav';
  import VCard from '@/components/Card';

  export default {
    name: 'LoginIndex',

    components: {
      VLayout,
      VCard,
    },

    data() {
      return {
        user: {
          username: '',
          password: '',
        },
        working: false,
        error: '',
      };
    },

    computed: {
      credentialsValid() {
        return this.user.username && this.user.password
      }
    },

    /**
     * The methods the page can use.
     */
    methods: {
      /**
       * Will log the user in.
       *
       * @param {Object} user The user to be logged in.
       */
      login(user) {
        if( !this.credentialsValid ) {
          return;
        }
        const self = this;
        self.working = true;
        self.success = false;
        self.error = '';

        this.$store.dispatch('auth/login', this.user)
          .catch((err) =>{
            self.error = err.message;
          })
          .finally(()=>{
            self.working = false;
          })
      },
    },
  };
</script>

<style lang="scss" scoped>

</style>
